import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon32: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M19.499 13.754a.5.5 0 0 1 .501.5v2.265A3.483 3.483 0 0 1 16.515 20h-2.268a.5.5 0 0 1 0-1h2.268a2.482 2.482 0 0 0 2.483-2.481v-2.265c0-.276.225-.5.501-.5Zm-18.998 0c.276 0 .501.224.501.5v2.265A2.482 2.482 0 0 0 3.485 19h2.268a.5.5 0 1 1 0 1H3.485A3.483 3.483 0 0 1 0 16.519v-2.265a.5.5 0 0 1 .501-.5ZM10 3.236c2.756 0 5.008 2.25 5.008 5.002v4.002c0 2.753-2.252 5.002-5.008 5.002-2.756 0-5.008-2.249-5.008-5.002V8.238c0-2.752 2.252-5.002 5.008-5.002Zm0 1a4.018 4.018 0 0 0-4.007 4.002v4.002c0 2.2 1.804 4.002 4.007 4.002a4.018 4.018 0 0 0 4.007-4.002V8.238c0-2.2-1.804-4.002-4.007-4.002Zm0 1.001c1.661 0 3.005 1.422 3.005 3.149v3.403a.588.588 0 0 1-.019.151 1.753 1.753 0 0 1-3.488-.26l.001-.036V8.49a.5.5 0 1 1 1.002 0v3.226a.752.752 0 0 0 1.502-.036V8.386c0-1.187-.909-2.148-2.003-2.148s-2.003.961-2.003 2.148v3.706c0 1.187.909 2.149 2.003 2.149a.5.5 0 1 1 0 1.001c-1.66 0-3.005-1.423-3.005-3.15V8.386c0-1.727 1.344-3.149 3.005-3.149ZM5.753 0a.5.5 0 0 1 0 1H3.485a2.48 2.48 0 0 0-2.483 2.48v2.265a.501.501 0 0 1-1.002 0V3.48C0 1.558 1.56 0 3.485 0h2.268Zm10.762 0A3.482 3.482 0 0 1 20 3.48v2.265a.5.5 0 0 1-1.002 0V3.48A2.48 2.48 0 0 0 16.515 1h-2.268a.5.5 0 1 1 0-1h2.268Z"
      />
    </Svg>
  )
}
